import { NgModule } from '@angular/core';
import { NetworkErrorDialogComponent } from './network-error-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@NgModule({
  declarations: [NetworkErrorDialogComponent],
  exports: [NetworkErrorDialogComponent],
  imports: [CommonModule, TranslateModule, MatButtonModule, MatDialogClose],
})
export class NetworkErrorDialogModule {}
